import type { ExcursionPage } from "../slug-excursions";
import sttrop from "@/assets/images/excursions/destinations/st-trop.webp";

const page: ExcursionPage = {
  slug: "saint-tropez",
  hero: {
    title: "Excursion Saint‑Tropez",
    subtitle:
      "Port mythique, plages et ruelles provençales, en toute sérénité.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "Réserver",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "Devis",
    image: sttrop,
  },
  highlights: {
    title: "Points forts",
    items: [
      { text: "Port de Saint‑Tropez, yachts et cafés mythiques" },
      { text: "Citadelle et ruelles provençales typiques" },
      { text: "Plages de Pampelonne à proximité" },
      { text: "Vues côtières sur la route varoise" },
    ],
  },
  itinerary: {
    title: "Itinéraire type",
    steps: [
      {
        title: "Trajet Cannes → Saint‑Tropez",
        description: "Paysages varois côtiers.",
      },
      {
        title: "Centre historique",
        description: "Port, citadelle (option), boutiques.",
      },
      { title: "Temps libre", description: "Pause café, plage selon saison." },
      {
        title: "Pampelonne (option)",
        description: "Baignade / plage privée selon saison.",
      },
    ],
  },
  practical: {
    title: "Infos pratiques",
    items: [
      { label: "Durée", value: "6 à 8 heures" },
      { label: "Astuce", value: "Éviter heures de pointe en été" },
      { label: "Départ", value: "Cannes" },
      { label: "Option", value: "Plage Pampelonne / Citadelle" },
    ],
  },
};

export default page;
